import { Base64 } from 'js-base64';
let localStorageTime  = 1000*60;
export function getToken() {
  // var token =localStorage.getItem('blade-auth');
  // var token1 = JSON.parse(token)
  // console.log('token123123sdfasfassdasd',new Date().getTime() - token1.time>localStorageTime)
  return localStorage.getItem('blade-auth');
}

export function setToken(token) {
  var curTime = new Date().getTime();
  localStorage.setItem('blade-auth',"bearer " + token);
  // localStorage.setItem('blade-auth',JSON.stringify({data: "bearer " + token,time:curTime}));
}

export function setCaptchaKey(key) {
  localStorage.removeItem('captcha-key');
  localStorage.setItem('captcha-key', key);
}

export function getCaptchaKey() {
  return localStorage.getItem('captcha-key');
}

export function getMfaDeviceId() {
  let deviceId = localStorage.getItem('mfa_device_id');
  if (!deviceId) {
    deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
    localStorage.setItem('mfa_device_id', deviceId);
  }
  return deviceId;
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem('current-user'));
}

export function setCurrentUser(account) {
  // console.log('account',account)
  localStorage.setItem('current-user', JSON.stringify(account));
}
export function getDict() {
  return JSON.parse(localStorage.getItem('dictList'));
}
export function getcodeValue(code, value) {
  if (value === '') return '';
  let data = getDict() || {};
  let result = '';
  if (!code) return result;
  if (
    Object.prototype.toString.call(value) ==
    "[object Number]"
  ) {
    value = value.toString();
  }
  data && data.length ? data.map((option) => {
    if (option.code == code) {
      option.children &&
        option.children.map((item) => {
          if (item.dictKey == value) {
            result = item.dictValue
          }
        });
    }
  }):result=[]
  return result;
}
export function getDictOne(params) {
  
  let dictList = JSON.parse(localStorage.getItem('dictList'));
  if(params){
    let dictOne = []
    dictList && dictList.map((item)=>{
        if(item.code == params){
          dictOne.push(item) 
        }
    })
    if(dictOne.length){
      // console.log('dictOne[0].chiildrendictOne[0].chiildren',dictOne[0].children);
      
      return dictOne[0].children
    }else{
      return []
    }
  }else{
    return dictList
  }
}
export function setDict(account) {
  // console.log('account',account)
  localStorage.setItem('dictList', JSON.stringify(account));
}

export function getUserId() {
  return localStorage.getItem('userId');
}

export function setUserId(user_id) {
  localStorage.setItem('userId', user_id);
}

//获取政务网单点登录是参数信息
export function getRecord() {
  let str={};
  if(localStorage.getItem('record')){
    str= JSON.parse( Base64.decode(localStorage.getItem('record')));
  }
  return str;
}
//设置政务网单点登录是参数信息
export function setRecord(record) {
  // console.log('account',account)
  let str= JSON.stringify(record);
  localStorage.setItem('record',Base64.encode(str));
}

//获取政务网单点登录是参数信息
export function getClickInfo() {
  let str='';
  if(localStorage.getItem('clickInfo')){
    str= JSON.parse( Base64.decode(localStorage.getItem('clickInfo')));
  }
  return str;
}
//设置政务网单点登录是参数信息
export function setClickInfo(record) {
  // console.log('account',account)
  let str= JSON.stringify(record);
  localStorage.setItem('clickInfo',Base64.encode(str));
}

export function removeAll() {
  localStorage.removeItem('blade-auth');
  localStorage.removeItem('current-user');
  localStorage.removeItem('userId');
  localStorage.removeItem('captcha-key');
  localStorage.removeItem('record');
  localStorage.removeItem('clickInfo');
  // localStorage.removeItem('dictList');
}

export function getTokenLogin() {
  return localStorage.getItem('token') || '';
}

export function setCitys(citys) {
  localStorage.removeItem('citys');
  localStorage.setItem('citys', JSON.stringify(citys));
}

export function getCitys() {
  return JSON.parse(localStorage.getItem('citys')) || [];
}


// 防抖函数
export const debounce=(fn, wait=500)=> {
  var timer = null;

  return function () {
      var context = this
      var args = arguments
      if (timer) {
          clearTimeout(timer);
          timer = null;
      }
      timer = setTimeout(function () {
          fn.apply(context, args)
      }, wait)
  }
}

//节流函数
export const throttle  = (fn, gapTime=500)=> {
  let _lastTime = null;
  
  return function () {
    let _nowTime = + new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn();
      _lastTime = _nowTime
    }
  }
}

// export function setToken(token) {
//   localStorage.setItem('token', token);
// }

